export default {
  SET_COURSES(state, courses) {
    state.courses = courses;
  },
  SET_NEW_COURSE(state, newCourse) {
    state.newCourse = newCourse;
  },
  SET_COURSE(state, course) {
    state.course = course;
  },
  SET_USER_PERMISSIONS(state, data) {
    state.userPermissions = data;
  },
  SET_INSTITUTION_TEMPLATE_ID(state, institutionTemplateId) {
    state.institutionTemplateId = institutionTemplateId;
  }
};
